import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/rental-reservation-booker-contact.dto';
export * from './dtos/rental-reservation-record.dto';
export * from './dtos/rental-reservation-list.dto';
export * from './dtos/rental-reservation-activity-event.dto';
export * from './dtos/rental-reservation-activity-event-hydration.dto';
export * from './dtos/rental-reservation-search.dto';
export * from './dtos/rental-reservations-stats.dto';
export * from './dtos/rental-reservation-links.dto';

export * from './enums/rental-reservation-action.enum';
export * from './enums/rental-reservation-record-category.enum';
export * from './enums/rental-reservation-status.enum';

export * from './functions/rental-reservation-status-to-color.function';

export * from './types/rental-reservations-filters';

export const rentalReservationValidators = {
  canPerformAction,
};
